import { createAction, props, union } from '@ngrx/store';

export const loadPaymentData = createAction(
  '[Payment] Load Payment Data',
  props<{ request: any }>()
);

export const loadPaymentDataSuccessful = createAction(
  '[Payment] Load Payment Data Successful',
  props<{ premium: any }>()
);

export const loadPaymentDataFailed = createAction(
  '[Payment] Load Payment Data Failed',
  props<{ error: any }>()
);

export const billingSucceededPayment = createAction(
  '[LoadPolicy] Billing Succeeded Payment',
  props<{ paymentDetails: any }>()
);

export const captureUserPaymentData = createAction(
  '[Payment] Capture User Payment Data',
  props<{ userPaymentData: any }>()
);

export const verifyBankData = createAction(
  '[Payment] Verify Users Bank Details',
  props<{ isPartialPayload: boolean, payload: any }>()
);

export const isPPDChangeRequired = createAction(
  '[Payment] Is ppd change required',
  props<{ isPPDChangeRequired: boolean}>()
);

export const verifyBankDataSuccessful = createAction(
  '[Payment] Verify Users Bank Details Successful',
  props<{ bankCheck: any }>()
);

export const updatePPDInpayload = createAction(
  '[Payment] Update payemnt date in payload',
  props<{ paymentDate: number }>()
);

export const verifyBankDataFailed = createAction(
  '[Payment] Verify Users Bank Details Failed',
  props<{ error: any }>()
);

export const verifyBankReset = createAction(
  '[Payment] Verify Users Bank Details reset'
);

export const verifyBankResetFalse = createAction(
  '[Payment] Verify Users Bank Details reset to false'
);

export const updateCreditCardDetailsOfRequestPayload = createAction(
  '[Payment] Update Credit Card Details Of Request Payload',
  props<{ creditCardDetails_dlg: any }>()
);

export const updateQuotedChangeBefore = createAction(
  '[Payment] Update Quoted Change Before',
  props<{ request: any }>()
);

export const resetPremiumBeforePayment = createAction(
  '[Payment] Resetting the premium Before Payment',
);

export const updateQuotedChangeBeforePaymentSuccessful = createAction(
  '[Payment] Update Quoted Change Successful',
  props<{ premiumBeforePayment: any }>()
);

export const updateQuotedChangeBeforePaymentFailed = createAction(
  '[Payment] Update Quoted Change Failed',
  props<{ premiumBeforePaymentError: any }>()
);

export const resetPaymentDataError = createAction(
  '[Payment] Reset Payment Data Error'
);

export const updatePaymentFailedStatus = createAction(
  '[Payment] Payment Attempt Failed',
  props<{ request: any }>()
);

export const paymentFailed = createAction(
  '[Payment] Payment Failed',
  props<{ paymentFailedStatus: any }>()
);

export const paymentSuccessful = createAction(
  '[Payment] Payment Successful'
);

export const editDirectDebitError = createAction(
  '[Payment] Edit Direct Debit Error',
  props<{ error: any }>()
);


const all = union({
  loadPaymentData,
  loadPaymentDataSuccessful,
  loadPaymentDataFailed,
  billingSucceededPayment,
  resetPaymentDataError,
  resetPremiumBeforePayment,
  updateQuotedChangeBefore,
  updateQuotedChangeBeforePaymentSuccessful,
  updateQuotedChangeBeforePaymentFailed,
  captureUserPaymentData,
  updatePaymentFailedStatus,
  paymentFailed,
  paymentSuccessful,
  verifyBankData,
  updatePPDInpayload,
  verifyBankDataSuccessful,
  verifyBankDataFailed,
  verifyBankResetFalse,
  verifyBankReset,
  isPPDChangeRequired,
  editDirectDebitError
});

export type PaymentActionsUnion = typeof all;
